import { render, staticRenderFns } from "./ManagementBanners.vue?vue&type=template&id=b1f86960&"
import script from "./ManagementBanners.vue?vue&type=script&lang=js&"
export * from "./ManagementBanners.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"
import style1 from "./ManagementBanners.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports